import { ISearchAdvancedOptions } from '../interfaces/search-advanced-options.interface';

// for future needs
export class AdvancedSearchOptions implements ISearchAdvancedOptions {
  field = '';
  exact = false;
  search = '';
}
